import type { EntryPoint, EntryPointComponent } from 'react-relay';

import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

import parameters, {
	type planSelectionPageModalQuery,
} from './__generated__/planSelectionPageModalQuery.graphql';
import type { PlanSelectionPageModalType } from './plan-selection-page-modal';

export type EntryPointParams = {
	cloudId: string;
	hamsProductKey: string;
};

type PlanSelectionPageModalComponent = EntryPointComponent<
	{
		planSelectionPageModalQuery: planSelectionPageModalQuery;
	},
	Record<string, never>,
	{
		onClose: () => void;
		type: PlanSelectionPageModalType;
	},
	Record<string, never>
>;

export const entryPoint: EntryPoint<PlanSelectionPageModalComponent, EntryPointParams> =
	createEntryPoint({
		root: JSResourceForInteraction<PlanSelectionPageModalComponent>(
			/* webpackChunkName: "@atlaskit-internal_edition-awareness-plan-selection-page-modal" */ './plan-selection-page-modal',
			{
				moduleId: 'edition-awareness-plan-selection-page-modal',
			},
		),
		getPreloadProps: ({ cloudId, hamsProductKey }: EntryPointParams) => ({
			entryPoints: {},
			extraProps: {},
			queries: {
				planSelectionPageModalQuery: {
					parameters,
					variables: {
						cloudId,
						hamsProductKey,
					},
				},
			},
		}),
	});
